import React, { useEffect } from "react";
import { RadioInput, SelectInput } from "../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import { facilityAction, masterActions } from "../../_store";
import { facilitySchema } from "../../validation/facilitySchema";

function FacilityFreeCredit({ errorMessage, setErrorMessage }) {
  const dispatch = useDispatch();
  const facilityInformationData = useSelector((x) => x?.facility?.facilityData);
  const { getFrequencyOption, getCreditsOption, Status } = useSelector(
    (state) => state.dropdownOptions
  );

  const handleChange = async (e, input) => {
    const facilityData = { ...facilityInformationData };
    if (
      input === "InmateFreeCreditFrequencyType" ||
      input === "InmateFreeCreditAmount"
    ) {
      facilityData[input] = e?.value ? e?.value : 0;
      dispatch(facilityAction.setFacilityData(facilityData));
      try {
        setErrorMessage((prev) => ({
          ...prev,
          [input]: "",
        }));
        const inputData = { [input]: e?.value ? e?.value : 0 }
        await facilitySchema.validateAsync(
          {
            ...inputData,
            "IsInmateFreeCredit": facilityData?.IsInmateFreeCredit
          },
          { abortEarly: false }
        );
      } catch (err) {
        // Find the error that matches the current field name
        const fieldError = err.details.find((error) => error.path.includes(input));

        if (fieldError) {
          setErrorMessage((prev) => ({
            ...prev,
            [input]: fieldError.message, // Set the specific field error from Joi
          }));
        }
      }
      return;
    }
    const { name, value } = e?.target;
    facilityData[name] = parseInt(value);
    dispatch(facilityAction.setFacilityData(facilityData));
  };

  return (
    <div className="mt-3 mb-3">
      <h4 className=" inner-header-bg text-color" style={{ cursor: "pointer" }} title="">
        <i class="fa-solid fa-circle-dollar-to-slot me-2"></i>Free Credit Setup{" "}
      </h4>
      <div className="row mb-12">
        <div className="col-sm-12 col-md-6 col-lg-4">
          <div className="form-floating mb-3">
            <SelectInput
              id="InmateFreeCreditFrequencyType"
              name="InmateFreeCreditFrequencyType"
              options={getFrequencyOption}
              isMulti={false}
              closeMenuOnSelect={true}
              isDisabled={false}
              isLoading={false}
              isClearable={facilityInformationData?.InmateFreeCreditFrequencyType !== 0}
              label="Frequency"
              placeholder="Select Credit"
              value={facilityInformationData?.InmateFreeCreditFrequencyType}
              handleChange={(e) =>
                handleChange(e, "InmateFreeCreditFrequencyType")
              }
              required
              errorMessage={errorMessage}
            />
          </div>
        </div>

        <div className="col-sm-12 col-md-6 col-lg-4">
          <div className="form-floating mb-3">
            <SelectInput
              id="InmateFreeCreditAmount"
              name="InmateFreeCreditAmount"
              options={getCreditsOption}
              isMulti={false}
              closeMenuOnSelect={true}
              isDisabled={false}
              isLoading={false}
              isClearable={facilityInformationData?.InmateFreeCreditAmount !== 0}
              label="Credits ($)"
              placeholder="Select State"
              value={facilityInformationData?.InmateFreeCreditAmount}
              handleChange={(e) => handleChange(e, "InmateFreeCreditAmount")}
              errorMessage={errorMessage}
              required
            />
          </div>
        </div>

        <div className="col-sm-12 col-md-6 col-lg-4">
          <div className="form-floating mb-3">
            <RadioInput
              label="Status"
              options={Status}
              name="FreeCreditActiveStatus"
              id="FreeCreditActiveStatus"
              errorMessage={errorMessage}
              handleChange={(e) => handleChange(e, "FreeCreditActiveStatus")}
              selectedValue={facilityInformationData?.FreeCreditActiveStatus}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(FacilityFreeCredit);
